import { render } from "./MarketplacesNews.vue?vue&type=template&id=5da6b054"
import script from "./MarketplacesNews.vue?vue&type=script&lang=ts"
export * from "./MarketplacesNews.vue?vue&type=script&lang=ts"

import "./MarketplacesNews.vue?vue&type=style&index=0&id=5da6b054&lang=scss"
script.render = render

export default script